// extracted by mini-css-extract-plugin
export var btn = "bs_v";
export var form = "bs_bw";
export var input = "bs_t";
export var msg = "bs_9";